module.exports = "/_next/static/images/penfold-og-image-f169c43dccaf3ef827cf10aef71b940d.jpg";